"use client";
import { ProductCardHorizontal } from "@/components/ui/productCardHorizontal";
import { Product } from "@/lib/models/product";
interface SuggestionListProps {
  productsSugestion: Product[];
  closeSuggestion: () => void;
}

export function SuggestionList({
  productsSugestion,
  closeSuggestion,
}: SuggestionListProps) {
  return (
    <>
      <div className="overflow-y-auto">
        {productsSugestion.map((suggestion) => (
          <div className="mt-2 bt-2 cursor-pointer" key={suggestion.id}>
            <ProductCardHorizontal
              product={suggestion}
              closeSuggestion={closeSuggestion}
            />
          </div>
        ))}
      </div>
    </>
  );
}
